<template>
  <div class="full_height_datatable" :style="heightStyle">
    <ag-grid-vue style="width: 100%; height: 100%"
                 class="ag-theme-balham"
                 :gridOptions="gridOptions"
                 :columnDefs="columnDefs"

                 :defaultColDef="defaultColDef"
                 :rowData="rowData"
                 :rowHeight="rowHeight"
                 :animateRows="true"
                 @first-data-rendered="onFirstDataRendered"

                 @row-clicked="onRowClicked"

                 :frameworkComponents="frameworkComponents"
                 :loadingOverlayComponent="loadingOverlayComponent"
                 :loadingOverlayComponentParams="loadingOverlayComponentParams"
                 :noRowsOverlayComponent="noRowsOverlayComponent"
                 :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import OverlayLoading from "./overlay_loading";
import OverlayNoRows from "./overlay_no_rows";

import {mapActions} from 'vuex'

export default {
  name: "datatable",
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows
  },
  props: {
    heightStyle: '',
    rowData: null,
    loadingMessage: {type: String, default: 'Loading...'},
    noRowsMessage: {type: String, default: 'No Rows Found'},
    columns: null,
    type: {type: String, required: false},
    subType: {type: String, required: false},
    compliance: {type: String, required: false},
    recordType: {type: String, required: false},
    paginationSize: {type: Number, required: false, default: 25}
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowHeight: null,

      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      noRowsOverlayComponent: null,
      noRowsOverlayComponentParams: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      pagination: true,
      paginationPageSize: this.paginationSize,
      rowStyle: {
        'border-bottom': 'white 1px solid',
        'border-top': 'white 1px solid',
      },
      onColumnResized: this.onColumnResized,
    };

    if (this.type === 'activity') {
      this.gridOptions.getRowStyle = function (params) {
        if (params.data.type === 'deleted') {
          return {background: '#f8d3d3'}
        }
        if (params.data.type === 'updated') {
          return {background: '#d9efff'}
        }
        if (params.data.type === 'created') {
          return {background: '#bbe8cf'}
        }
      }
    }
    if (this.type === 'orders') {
      this.gridOptions.getRowStyle = function (params) {
        if (params.data.order_progress_status === 'Ended') {
          return {background: '#bebebe'}
        }
        else if (params.data.order_signed === 0) {
          return {background: '#fde9d5'}
        }

        // if (params.data.order_signed === 1) {
        //   return {background: '#e0f0e4'}
        // }
      }
    }
    if (this.compliance === 'recruitment') {
      this.gridOptions.getRowStyle = function (params) {
        if (!params.data.worker_compliant) {
          if (params.data.row_color === 'red') {
            return {background: '#f8d3d3'}
          }
          else if (params.data.row_color === 'amber') {
            return {background: '#ffe59a'}
          }
          else if (params.data.row_color === 'blue') {
            return {background: '#cdd9ff'}
          }

        }
      }
    }
    // if (this.type === 'timesheets_companies') {
    //   this.gridOptions.getRowStyle = function (params) {
    //     if (!params.data.worker_compliant) {
    //       if (params.data.row_color === 'red') {
    //         return {background: '#f8d3d3'}
    //       }
    //       else if (params.data.row_color === 'amber') {
    //         return {background: '#ffe59a'}
    //       }
    //       else if (params.data.row_color === 'blue') {
    //         return {background: '#cdd9ff'}
    //       }

    //     }
    //   }
    // }

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      filterParams: {newRowsAction: 'keep', buttons: ['reset'],},
      cellStyle: {"white-space": "normal"},
      unSortIcon: true,
      suppressMenu: true,
      autoHeight: true,
      suppressSizeToFit: false,
      flex: 1,
      wrapText: true,     // <-- HERE
    };
    this.frameworkComponents = {
      customLoadingCellRenderer: OverlayLoading,
      customNoRowsOverlay: OverlayNoRows,
    };
    this.loadingOverlayComponent = 'customLoadingCellRenderer';
    this.loadingOverlayComponentParams = {loadingMessage: this.loadingMessage};
    this.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.noRowsOverlayComponentParams = {noRowsMessage: this.noRowsMessage};

    this.columnDefs = this.columns;

    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_workers' && $event.type === 'delete' && this.type === 'workers') {
        // find row based on worker id and then remove
        this.rowData.splice(this.rowData.findIndex(r => r.id === this.$store.state.workers.delete_worker_id), 1);
      }
      if ($event.table === 'all_workers' && $event.type === 'update' && this.type === 'workers') {
        // find row based on worker id and then update
        let rowID = this.rowData.findIndex(r => r.id === this.$store.state.workers.update_worker_id);
        this.gridApi.refreshCells({force: true, rowNodes: [rowID]})
      }

      if ($event.table === 'all_companies' && $event.type === 'delete' && this.type === 'companies') {
        // find row based on company id and then remove
        this.rowData.splice(this.rowData.findIndex(r => r.id === this.$store.state.companies.delete_company_id), 1);
      }
      if ($event.table === 'all_companies' && $event.type === 'update' && this.type === 'companies') {
        let rowID = this.rowData.findIndex(r => r.id === this.$store.state.companies.update_company_id);
        this.gridApi.refreshCells({force: true, rowNodes: [rowID]});
      }

      if ($event.table === 'all_contacts' && $event.type === 'delete' && this.type === 'contacts') {
        // find row based on contact id and then remove
        this.rowData.splice(this.rowData.findIndex(r => r.id === this.$store.state.contacts.delete_contact_id), 1);
      }
      if ($event.table === 'all_contacts' && $event.type === 'update' && this.type === 'contacts') {
        // find row based on contact id and then update
        let rowID = this.rowData.findIndex(r => r.id === this.$store.state.contacts.update_contact_id);
        this.gridApi.refreshCells({force: true, rowNodes: [rowID]})
      }
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    ...mapActions(['showRightInfo']),

    onRowClicked(params) {
        if (this.type === 'search_workers') {
            this.$store.commit('SET_WORKER_ROW_ID', {
                row_id: params.node.id
            });
            const routeData = this.$router.resolve({name: 'worker_profile', query: {worker_id: params.data.id}});
            window.open(routeData.href, '_blank');
            return;
        }
      if (this.type === 'news') {

        // DO NOTHING - we have buttons in row


        // this.$store.commit('CURRENT_EDIT_NEWS_ARTICLE_ID', params.data.id);
        // this.$nextTick(() => {
        //   // this.close_right_info();
        //   this.$router.push('/news/edit');
        //   this.$tabs.refresh('/news/edit', true)
        // });
      }
      else if (this.type === 'geotec') {
            this.$router.push({
              name: 'clock_in_out_details',
              params: params.data
            });
      }
      else if (!this.$store.state.auth.me.roles.includes('client_sub') && !this.$store.state.auth.me.roles.includes('client_auth')) {
        if (this.type !== 'notes') {
          if (this.type === 'address') {
            this.$store.commit('SHOW_VIEW_ADDRESS_MODAL', {
              id: params.data.id,
              type: params.data.address_type
            });
            this.$store.state.addresses.view_modal = true;
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_address_modal'));
          }
          else if (this.type === 'contacts') {
            this.$store.commit('SHOW_VIEW_CONTACT_MODAL', {
              contact_id: params.data.id,
              company_id: params.data.client_id
            });
            this.$store.state.contacts.view_modal = true;
            this.$store.commit('SET_CONTACT_ROW_ID', {
              row_id: params.node.id
            });
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_contact_modal'));
          }
          else if (this.type === 'activity') {
            if (this.recordType === 'contact' || this.recordType === 'company') {
              if ('contact_model_type' in params.data) {
                this.$store.commit('SHOW_VIEW_LOG_MODAL', {
                  log_type: 'contact',
                  id: params.data.id,
                  log_by: params.data.user,
                  log_by_id: params.data.log_by_id,
                  new_values: params.data.new_values,
                  old_note_by: params.data.old_note_by,
                  old_values: params.data.old_values,
                  type: params.data.type,
                  updated_at: params.data.updated_at,
                  contact_id: params.data.contact_id,
                  contact_model_id: params.data.contact_model_id,
                  contact_model_type: params.data.contact_model_type,
                  client_id: params.data.client_id
                });
                this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
              }
              if ('client_model_type' in params.data) {
                this.$store.commit('SHOW_VIEW_LOG_MODAL', {
                  log_type: 'client',
                  id: params.data.id,
                  log_by: params.data.user,
                  log_by_id: params.data.log_by_id,
                  new_values: params.data.new_values,
                  old_note_by: params.data.old_note_by,
                  old_values: params.data.old_values,
                  type: params.data.type,
                  updated_at: params.data.updated_at,
                  contact_id: params.data.contact_id,
                  client_id: params.data.client_id,
                  client_model_id: params.data.client_model_id,
                  client_model_type: params.data.client_model_type,
                });
                this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
              }
            }
            if (this.recordType === 'worker') {
              this.$store.commit('SHOW_VIEW_LOG_MODAL', {
                log_type: 'worker',
                id: params.data.id,
                log_by: params.data.log_by,
                log_by_id: params.data.log_by_id,
                log_by_type: params.data.log_by_type,
                new_values: params.data.new_values,
                old_note_by: params.data.old_note_by,
                old_values: params.data.old_values,
                type: params.data.type,
                updated_at: params.data.updated_at,
                worker_id: params.data.worker_id,
                worker_model_id: params.data.worker_model_id,
                worker_model_type: params.data.worker_model_type,
              });
              this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
            }
          }
          else if (this.type === 'mileage') {
          }
          else if (this.subType === 'pay_group') {
            params.data.id = params.data.company_id
            this.showRightInfo({data: params.data, type: this.type});
          }
          else if (this.type === 'timesheets_companies') {
            // cosnole.log('Click row - where we go Wojtek ?');
            // window.location.href = response.data.redirect_url;
            // window.location.href = '/workers/all';

            // this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.$store.state.right_info.data.worker_id);
            // this.$store.commit('CURRENT_PROFILE_WORKER_ID', 26317);
            // this.$store.commit('SET_WORKER_TAB_INDEX', 0);
            // this.$nextTick(() => {
            //   // this.close_right_info();
            //   this.$router.push('/workers/profile');
            //   this.$tabs.refresh('/workers/profile', true)
            // });
          }
          else {
            if (this.type === 'workers') {
              this.$store.commit('SET_WORKER_ROW_ID', {
                row_id: params.node.id
              });
            }
            if (this.type === 'companies') {
              // console.log(params.node.id)
              this.$store.commit('SET_COMPANY_ROW_ID', {
                row_id: params.node.id
              });
            }
            this.$store.commit('CURRENT_RIGHT_INFO_TABLE_ROW', {
              node_id: params.node.id
            });
            if (this.subType === 'no_id') {
              this.showRightInfo({data: params.data, type: this.type, sub_type: 'no_id'});
            }
            else {
              this.showRightInfo({data: params.data, type: this.type});
            }
          }
        }
        if (this.type === 'notes') {
          let name = null, rType = null;
          if (this.type === 'notes' && params.data.sunset && params.data.sunset === 1) {
            switch (this.recordType) {
              case 'company':
                // contact row in table
                if (params.data.contact_id !== null) {
                  name = params.data.contact_name;
                  rType = 'contact'
                }
                // client row in table
                else {
                  name = params.data.company_name;
                  rType = 'company'
                }
                this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
                  id: params.data.id,
                  name: name,
                  type: rType,
                  contacts: null
                });
                this.$store.state.notes.view_modal = true;
                this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
                return;
              case 'order_job':
                name = params.data.belongs_to.order_ref;
                break;
              case 'worker':
                name = params.data.worker_name;
                break
              case 'contact':
                name = params.data.contact_name;
                break;
            }

            this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
              id: params.data.id,
              name: name,
              type: this.recordType,
              contacts: null
            });
            this.$store.state.notes.view_modal = true;
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
          }
          else if (this.recordType === 'company') {
            // contact row in table
            if (params.data.contact_id !== null) {
              name = params.data.belongs_to.person.first_name + ' ' + params.data.belongs_to.person.surname;
              rType = 'contact'
            }
            // client row in table
            else {
              name = params.data.belongs_to.company_name;
              rType = 'company'
            }
            this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
              id: params.data.id,
              name: name,
              type: rType,
              contacts: null
            });
            this.$store.state.notes.view_modal = true;
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
          }
          else {
            if (this.recordType === 'worker') {
              name = params.data.belongs_to.person.first_name + ' ' + params.data.belongs_to.person.surname;
            }
            if (this.recordType === 'contact') {
              name = params.data.belongs_to.person.first_name + ' ' + params.data.belongs_to.person.surname;
            }
            if (this.recordType === 'order_job') {
              name = params.data.belongs_to.order_ref;
            }

            this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
              id: params.data.id,
              name: name,
              type: this.recordType,
              contacts: null
            });
            this.$store.state.notes.view_modal = true;
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
          }

        }
        this.$store.commit('CURRENT_RIGHT_INFO_TABLE_ROW', {
          node_id: params.node.id
        });
      }
      else if (this.$store.state.auth.me.role === 'client_sub') {
        // console.log(params.data)
      }
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      params.api.resetRowHeights();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    }
  },
}
</script>
